import React, { FC, useState } from "react"
import { Grid, MenuItem, Select, CardContent, Typography } from "@material-ui/core"

import { Portlet } from "@/components"
import MessageItem from "@/components/ChatMessageBuilder/MessageItem"

import { WABAChannelMessageTemplate } from "@/@integrations/WABA/protocols/wabaChannelMessageTemplate"
import { getTemplateCategoryChip } from "@/@integrations/WABA/utils/template"

import { colors } from "@/styles/colors"

type WABATemplateSelectorProps = {
	selectedWABATemplateId?: number
	disabled?: boolean
	templates?: WABAChannelMessageTemplate[]
	onChange: (templateId: number | undefined) => void
}

const WABATemplateSelector: FC<WABATemplateSelectorProps> = ({
	selectedWABATemplateId,
	disabled,
	templates,
	onChange
}) => {
	const [selectedTemplateId, setSelectedTemplateId] = useState<number | undefined>(selectedWABATemplateId)

	const selectedTemplate = templates?.find(template => template.id === selectedTemplateId)

	const handleSelectTemplate = (templateId: number) => {
		setSelectedTemplateId(templateId)

		onChange?.(templateId)
	}

	return (
		<Portlet elevation={1}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography
						variant="h4"
						color="textPrimary"
						gutterBottom
					>
                        Nome do template
					</Typography>

					<Select
						fullWidth
						variant="outlined"
						value={selectedTemplateId}
						disabled={disabled}
						placeholder="Selecione um template"
						onChange={({ target }) => handleSelectTemplate(target.value as number)}
						displayEmpty
						renderValue={(value) => {
							if (!value) {
								return <span style={{ color: colors.gray[300] }}>Selecione um template</span>
							}
							const template = templates?.find(wabaTemplate => wabaTemplate.id === value)

							if (!template) {
								return null
							}

							return (
								<Grid container alignItems="center" justifyContent="space-between">
									<Grid item>
										{template.name}
									</Grid>
									<Grid item>
										{getTemplateCategoryChip(template.category)}
									</Grid>
								</Grid>
							)
						}}
						MenuProps={{
							PaperProps: {
								style: {
									maxHeight: 300,
									width: 400
								}
							},
							anchorOrigin: {
								vertical: "bottom",
								horizontal: "left"
							},
							transformOrigin: {
								vertical: "top",
								horizontal: "left"
							},
							getContentAnchorEl: null
						}}
					>
						{templates?.map(template => (
							<MenuItem
								key={template.id}
								value={template.id}
								disabled={template.status !== "approved"}
							>
								<Grid container alignItems="center" justifyContent="space-between">
									<Grid item>
										{template.name}
									</Grid>
									<Grid item>
										{getTemplateCategoryChip(template.category)}
									</Grid>
								</Grid>
							</MenuItem>
						))}
					</Select>
				</Grid>

				<Grid item xs={12}>

					{selectedTemplate && (
						<>
							<Typography variant="h4" color="textPrimary" gutterBottom>
                                Conteúdo
							</Typography>

							<Portlet
								style={{
									padding: 16,
									borderRadius: 8,
									background: `linear-gradient(310deg, ${colors.purple[100]}, ${colors.beige[100]})`
								}}
							>
								<CardContent>
									<MessageItem
										type={selectedTemplate.message.type}
										content={selectedTemplate.message.content}
										extraData={selectedTemplate.message.extraData}
										isDefaultSize={false}
										copySpecial={false}
									/>
								</CardContent>
							</Portlet>
						</>
					)}
				</Grid>
			</Grid>
		</Portlet>
	)
}

export default WABATemplateSelector
